import styled from "styled-components";

export const ProductContainer = styled.div`
  display: flex;
  gap: 12px;
`;
